theme.multi_media_slider = function(){
  $('.multi_media_slider').slick({
    infinite: true,
    slidesToShow: 4,
    arrows:false,
    centerMode: true,
    centerPadding: '80px',
    focusOnSelect: true,
    autoplay:true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2,
          autoplay:true,
          autoplaySpeed: 1000
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
          autoplay:true,
          autoplaySpeed: 1000,
        }
      }
    ]
  });
}
theme.uporto_slider_section = function() {
  $('.uporto_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
theme.testimonial_review_slider = function() {
  $('.testimonial_review_block_slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
theme.tab_content = function(){
  var tab_heading = document.querySelectorAll('.tab-head');
  tab_heading.forEach(button => button.addEventListener('click',function(){
      var index = this.getAttribute('data-index');
      var closest = this.closest('.tab-content-main-wrapper');
      closest.querySelectorAll('.tab-head').forEach(function(item){
          item.classList.remove('active');
      });
      closest.querySelectorAll('.tab-content').forEach(function(item){
          item.style.display = 'none';
      });
      closest.querySelector(`.tab-head[data-index='${index}']`).classList.add('active');
      closest.querySelector(`.tab-content[data-index='${index}']`).style.display = 'block';
      
  }));
}
theme.after_before_slider = function() {  
  if ($(window).width() < 750) { 
    $('.after_before_slider').slick('unslick');
  } else {
      $('.after_before_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        dots: true,
        centerMode: true,
        centerPadding: '600px',
        responsive: [
          {
            breakpoint:1500,
            settings: {
              centerPadding: '450px',
            }
          },
          {
            breakpoint:1300,
            settings: {
              centerPadding: '400px',
            }
          },
          {
            breakpoint:1200,
            settings: {
              centerPadding: '350px',
            }
          },
          {
            breakpoint:990,
            settings: {
              centerPadding: '250px',
            }
          }
        ]
      });
    }
}

theme.pdp_after_before_slider = function() {
  if ($(window).width() < 750) { 
    $('.pdp_after_before_slider').slick('unslick');
  } else {
    $('.pdp_after_before_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:false,
      dots: true,
      centerMode: true,
      centerPadding: '600px',
      responsive: [
        {
          breakpoint:1500,
          settings: {
            centerPadding: '450px',
          }
        },
        {
          breakpoint:1300,
          settings: {
            centerPadding: '400px',
          }
        },
        {
          breakpoint:1200,
          settings: {
            centerPadding: '350px',
          }
        },
        {
          breakpoint:990,
          settings: {
            centerPadding: '250px',
          }
        }
      ]
    });
  }
}

theme.ingredients_slider = function(){
  $('.how-to-use-slider').slick({
    infinite: true,
    slidesToShow: 1,
    arrows:false,
    focusOnSelect: true,
    autoplay:true,
    autoplaySpeed: 5000,
    dots: true
  });
}


theme.ingredients_slider = function(){
  $('.ingredients-slider').slick({
    infinite: true,
    slidesToShow: 1,
    arrows:false,
    focusOnSelect: true,
    autoplay:true,
    autoplaySpeed: 5000,
    dots: true
  });
}
theme.client_review_slider = function() {
  $('.client_review_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows:false,
    dots: true,
    centerMode: true,
    centerPadding: "30%",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerPadding: "20%",
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          centerPadding: "10%",
        }
      }
    ]
  });
}
theme.announceCounter = function(){
  var timeLimitInMinutes =  document.getElementById('timer').innerHTML;
  var timeLimitInSeconds = timeLimitInMinutes * 60;
  var timerElement = document.getElementById('timer');

  function startTimer() {
    timeLimitInSeconds--;
    var minutes = Math.floor(timeLimitInSeconds / 60);
    var seconds = timeLimitInSeconds % 60;

    if (timeLimitInSeconds < 0) {
      timerElement.textContent = '00:00';
      clearInterval(timerInterval);
      return;
    }

    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    timerElement.textContent = minutes + 'Dakika : ' + seconds + 'Saniye';
  }

  var timerInterval = setInterval(startTimer, 1000);

}
document.addEventListener("DOMContentLoaded", (event) => {
  theme.multi_media_slider();
  theme.announceCounter();
  theme.uporto_slider_section();
  theme.testimonial_review_slider();
  theme.tab_content();
  theme.ingredients_slider();
  theme.client_review_slider();
  if (window.matchMedia("(min-width: 750px)").matches) {
    theme.after_before_slider();
    theme.pdp_after_before_slider();
  }
});

// $(window).on('resize', function(){
//   if (window.matchMedia("(min-width: 750px)").matches) {
//     theme.pdp_after_before_slider();
//     theme.after_before_slider();
//   }
// });
$(window).on('resize', function(){
  theme.pdp_after_before_slider();
  theme.after_before_slider();
});
